<template>
  <div v-show="show">
    <v-popup class="qrcode-popup" :value="show" v-backFn="{ show }" :close-on-click-overlay="false">
      <div class="card-wrap">
        <div class="name">{{ sellerName }}</div>
        <div class="phone">
          <a :href="hrefPhone" @click="callUp">{{ sellerPhone }}</a>
        </div>
        <div class="con-wrapper">
          <img class="img" :src="sellerPic" show-menu-by-longpress="true" />
          <p class="tip one">①截图保存二维码到相册</p>
          <p class="tip one">②打开微信识别二维码联系专属店员</p>
        </div>
      </div>
    </v-popup>
    <div class="close" @click="close"></div>
  </div>
</template>

<script>
import create from '../create'
import fetch from 'api/fetch'
import { app } from 'utils'
import clientEnv from 'utils/clientEnv'
export default create({
  name: 'contact-guide',
  props: {
    guiderInfo: {
      type: Object,
      default: () => {}
    },
    // 组件自己查询数据，不使用外传的数据
    querySeller: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      sellerPic: '',
      sellerPhone: '',
      sellerName: '',
      show: false,
      hrefPhone: ''
    }
  },
  methods: {
    callUp() {
      if (clientEnv.isIOS) {
        app.callUp(this.sellerPhone)
      }
    },
    async open({ sellerPic, sellerName, sellerPhone, sellerCode }) {
      // 订单列表
      if (this.querySeller) {
        try {
          const data = await fetch({
            url: '/v1/my/order/querySellerInfo',
            params: { sellerCode }
          })

          this.sellerPic = data.sellerPic
          this.sellerPhone = data.sellerPhone
          this.sellerName = data.sellerName
          this.show = true
        } catch (e) {
          if (e.code !== undefined && e.code !== 0) {
            this.$toast(e.msg)
          }
        }
      } else {
        this.sellerPic = sellerPic
        this.sellerPhone = sellerPhone
        this.sellerName = sellerName
        this.show = true
      }
      this.hrefPhone = 'tel:' + this.sellerPhone
    },
    close() {
      this.show = false
    }
  }
})
</script>

<style lang="scss" scoped>
.qrcode-popup {
  border-radius: 45px;
  overflow: unset;
}
.card-wrap {
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: top;
  align-items: center;
  width: 964px;
  height: 1299px;
  background-color: #fff;
  padding: 87px;
  border-radius: 45px;
  .name {
    font-size: 51px;
    line-height: 60px;
    color: #000;
  }
  .phone {
    position: relative;
    font-size: 42px;
    line-height: 42px;
    padding-left: 57px;
    margin-top: 18px;
    a {
      color: #456fff;
    }
    &::before {
      content: '';
      display: block;
      width: 42px;
      height: 42px;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      background: url('https://topicstatic.vivo.com.cn/f5ZUD0HxhQMn3J32/wukong/img/611119d0-dd98-4d50-9245-264d7e1929a0.png')
        center no-repeat;
      background-size: cover;
    }
  }
  .con-wrapper {
    margin-top: 47px;
    padding: 47px;
    background: #f7f7f7;
  }
  .img {
    display: block;
    width: 676px;
    height: 676px;
  }
  .tip {
    font-size: 34px;
    line-height: 43px;
    color: #888;
    text-align: center;
    &.one {
      margin-top: 28px;
    }
    &.two {
      margin-top: 2px;
    }
  }
}
.close {
  top: calc(50% + 750px);
  left: 50%;
  position: fixed;
  z-index: 3000;
  background-color: rgba(0, 0, 0, 0.4);
  &::before {
    content: '';
    position: absolute;
    width: 81px;
    height: 81px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: url('https://zhanstatic.vivo.com.cn/wukong-zhan/img/4e06acb3-d6bf-4335-a205-086696878bd9nwebp_compress.png')
      no-repeat center;
    background-size: cover;
  }
}
.is-vertical,
.is-horizontal {
  .card-wrap {
    width: 800px;
    height: auto;
    padding: 60px;
    text-align: center;
    .img {
      display: inline-block;
      width: 400px;
      height: 400px;
    }
  }
  .qrcode-popup {
    top: 45%;
  }
  .close {
    top: calc(50% + 500px);
  }
}
</style>
